import request from '@/utils/request'

const url = 'admin/user_member_add'

export function submitMemberAdd(data) {
  return request({
    url: `${url}/submit`,
    method: 'post',
    data
  })
}

export function editMemberAdd(data) {
  return request({
    url: `${url}/edit`,
    method: 'post',
    data
  })
}

export function listMemberAdd(data) {
  return request({
    url: `${url}/list`,
    method: 'post',
    data
  })
}

export function detailMemberAdd(data) {
  return request({
    url: `${url}/detail`,
    method: 'post',
    data
  })
}

export function level1ApproveMemberAdd(data) {
  return request({
    url: `${url}/level1Approve`,
    method: 'post',
    data
  })
}

export function level2ApproveMemberAdd(data) {
  return request({
    url: `${url}/level2Approve`,
    method: 'post',
    data
  })
}

export function deleteMemberAdd(data) {
  return request({
    url: `${url}/deleteRecord`,
    method: 'post',
    data
  })
}
